import type { PropType } from "vue";

import { State } from "@/abc-dsk/options";

import { Variant } from "./common";

export { color, size } from "@/abc-dsk/props";

export const state = {
  type: String as PropType<State>,
  default: State.None
};

export const variant = {
  type: String as PropType<Variant>,
  default: Variant.Positive
};

export const presentational = {
  type: Boolean,
  default: false
};
